import React, { useEffect, useState } from "react";
import s from "./ModalRaffles.module.css";

//services
import raffleService from "../../../../../api/raffles/RafflesService";

//assets
import { t } from "i18next";
import { useDispatch, useSelector } from "react-redux";

import {
  Grid,
  Modal,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Pagination,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ModalRaffles = ({ open, setOpen, gameId, modeId, setRaffleSelected }) => {
  const { textColor } = useSelector((state) => state.local);

  const dispatch = useDispatch();

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setLoading(true);
    raffleService
      .getFilteredRaffles(gameId, modeId, page, null, dispatch)
      .then((res) => {
        setItems(res.content);
        setTotalPages(res.totalPages);
      })
      .then(() => setLoading(false));
  }, [page]);

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <Grid container>
        <Grid
          xs={12}
          md={8}
          lg={4.5}
          item
          container
          className={s.boxModal}
          sx={{ bgcolor: "#EEEEEE" }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid item xs={11} className={s.exit}>
              <div className={s.titleModal}>
                <p>{t("products")}</p>
                <span>{t("selectProduct")}</span>
              </div>
              <CloseIcon
                onClick={() => setOpen(false)}
                className={s.exitIcon}
                sx={{ color: "primary.dark" }}
              />
            </Grid>
          </Grid>

          {loading ? (
            <Grid item xs={12} className={s.loader}>
              <CircularProgress size="3rem" />
            </Grid>
          ) : items?.length ? (
            <Grid item xs={11} sx={{ mb: 3, minHeight: "40vh" }}>
              <TableContainer className={s.tableContainer}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                        }}
                      >
                        {t("game")}
                      </TableCell>
                      <TableCell
                        sx={{
                          backgroundColor: "primary.main",
                          color: textColor,
                        }}
                      >
                        {t("product")}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {items.map((item, i) => (
                      <React.Fragment key={i}>
                        {" "}
                        <TableRow
                          sx={{
                            transition: "0.2s",
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "primary.light" },
                          }}
                          onClick={() => {
                            setOpen(false);
                            setRaffleSelected(item);
                          }}
                        >
                          <TableCell>{item?.game?.name || "-"}</TableCell>
                          <TableCell>
                            {item?.number
                              ? `${t("drawNumber")}: ${item?.number}`
                              : item?.serie
                                ? `${t("serie")}: ${item?.serie}`
                                : "-"}
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          ) : (
            <Grid item xs={12} className={s.loader}>
              {t("noResults")}
            </Grid>
          )}

          <Grid
            item
            xs={12}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Pagination
              page={page}
              count={totalPages}
              color="primary"
              onChange={(e, v) => setPage(v)}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ModalRaffles;
